export default __webpack_public_path__ + "static/media/Logo-2.9f24a9fe.svg";